import rizalport from '../images/uiux/rizal-port.png'
import kamus from '../images/uiux/kamus-ketengban.png'
import kalkulator from '../images/uiux/kalkulator.png'
import jogja from '../images/uiux/explore-jogja.png'
import archipelago from '../images/uiux/archipelago.png'


const uiux = [
    {
        id: 1,
        src: rizalport,
        title: "Rizal's Portfolio",
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur illum cum provident. Beatae expedita doloribus adipisci iusto facere fugiat alias!',
    },
    {
        id: 2,
        src: kamus,
        title: "Kamus Bahasa Suku Ketengban",
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur illum cum provident. Beatae expedita doloribus adipisci iusto facere fugiat alias!',
    },
    {
        id: 3,
        src: kalkulator,
        title: "Kalkulator Bilangan Suku Rani",
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur illum cum provident. Beatae expedita doloribus adipisci iusto facere fugiat alias!',
    },
    {
        id: 4,
        src: jogja,
        title: "Explore Jogja Design Exploration",
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur illum cum provident. Beatae expedita doloribus adipisci iusto facere fugiat alias!',
    },
    {
        id: 5,
        src: archipelago,
        title: "Archipelago Music Streaming Coursework",
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur illum cum provident. Beatae expedita doloribus adipisci iusto facere fugiat alias!',
    },

];

export default uiux;